var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticClass:"underline-button",attrs:{"type":"text"},on:{"click":_vm.copy}},[_vm._v("Copy")]),_c('div',{class:['select-text', {selected: _vm.selected}]},[_c('span',{ref:"note",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.note)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }